import { Component, type ReactNode } from "react";

/** If one part of the screen breaks, only that part says so; the rest keeps working. */
export class Guard extends Component<{ children: ReactNode; label?: string }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(e: unknown) { console.error("Hub screen error", e); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="col"><div className="empty" style={{ margin: "80px auto", textAlign: "center" }}>
        Something went wrong showing {this.props.label ?? "this"}.<br />
        <button className="btn" style={{ marginTop: 12 }} onClick={() => location.reload()}>Reload</button>
      </div></div>
    );
  }
}
